import { Component } from '@angular/core'

/**
 * Dummy component that displays an overview of the upcoming crew market place
 */
@Component({
  selector: 'ngx-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss'],
  standalone: true
})
export class MarketplaceComponent {}
